import type { FunctionComponent } from 'react';

import classNames from 'classnames';
import { isNil } from 'lodash-es';

import type { SegmentEntityWithIdNormalized } from '@iconik-io/shared-lib/src/redux/entities/normalized/segment';
import type { TimecodeOptions } from '@iconik-io/shared-lib/src/utils/get_proxy_timecode_options';
import { useBasePlayerContext } from '@iconik-io/unified-player-ui-react';

import { Timecode } from '../../../../components/fields/timecode/timecode';
import IconButton from '../../../../ui/icon_button/icon_button';

import mixins from '../../../../styles/core/mixins.module.css';
import styles from './transcription_segment.module.css';

const speakerColorClasses = [
  styles.speaker_color_0,
  styles.speaker_color_1,
  styles.speaker_color_2,
  styles.speaker_color_3,
];

type Props = {
  speakerLabel: string;
  segment: SegmentEntityWithIdNormalized;
  onEdit: () => void;
  timecodeOptions: TimecodeOptions | undefined;
};

const TranscriptionSegment: FunctionComponent<Props> = (props) => {
  const { store } = useBasePlayerContext();

  const transcription = props.segment.transcription;
  return (
    <div key={props.segment.id} className={styles.segment}>
      <div className={styles.header}>
        {transcription?.speaker !== undefined ? (
          <div
            onClick={props.onEdit}
            className={classNames(
              styles.speaker,
              !isNil(transcription.speaker)
                ? speakerColorClasses[transcription.speaker]
                : undefined,
            )}
          >
            {props.speakerLabel}
          </div>
        ) : null}
        <div className={styles.timecode_buttons}>
          <IconButton
            type="button"
            iconName="player_play"
            iconSizeUAD="xs"
            onClick={() => {
              store.segment.setSelectedSegmentIds(
                props.segment.id ? [props.segment.id] : [],
              );
              store.playableMedia.play();
            }}
            className={classNames(styles.play_button)}
          />

          {props.timecodeOptions ? (
            <button
              type="button"
              className={classNames(styles.seek_button, mixins.reset_button)}
              onClick={() => {
                store.segment.setSelectedSegmentIds(
                  props.segment.id ? [props.segment.id] : [],
                );
              }}
            >
              <Timecode
                timecodeOptions={props.timecodeOptions}
                value={Number(props.segment.time_start_milliseconds)}
              />{' '}
              -{' '}
              <Timecode
                timecodeOptions={props.timecodeOptions}
                value={Number(props.segment.time_end_milliseconds)}
              />
            </button>
          ) : null}
        </div>
      </div>
      <div className={styles.text} onClick={props.onEdit}>
        {props.segment.segment_text}
      </div>
    </div>
  );
};

export default TranscriptionSegment;
